export const STORM_DEFAULT_DOCS = "https://docs.stormsoftware.com";
export const STORM_DEFAULT_HOMEPAGE = "https://stormsoftware.com";
export const STORM_DEFAULT_CONTACT = "https://stormsoftware.com/contact";
export const STORM_DEFAULT_SUPPORT = "https://stormsoftware.com/support";
export const STORM_DEFAULT_LICENSING = "https://stormsoftware.com/license";
export const STORM_DEFAULT_LICENSE = "Apache-2.0";
export const STORM_DEFAULT_RELEASE_BANNER =
  "https://public.storm-cdn.com/brand-banner.png";
export const STORM_DEFAULT_SOCIAL_TWITTER = "StormSoftwareHQ";
export const STORM_DEFAULT_SOCIAL_DISCORD = "https://discord.gg/MQ6YVzakM5";
export const STORM_DEFAULT_SOCIAL_TELEGRAM = "https://t.me/storm_software";
export const STORM_DEFAULT_SOCIAL_SLACK =
  "https://join.slack.com/t/storm-software/shared_invite/zt-2gsmk04hs-i6yhK_r6urq0dkZYAwq2pA";
export const STORM_DEFAULT_SOCIAL_MEDIUM = "https://medium.com/storm-software";
export const STORM_DEFAULT_SOCIAL_GITHUB = "https://github.com/storm-software";

export const STORM_DEFAULT_RELEASE_FOOTER = `
Storm Software is an open source software development organization with the mission is to make software development more accessible. Our ideal future is one where anyone can create software without years of prior development experience serving as a barrier to entry. We hope to achieve this via LLMs, Generative AI, and intuitive, high-level data modeling/programming languages.

Join us on [Discord](${STORM_DEFAULT_SOCIAL_DISCORD}) to chat with the team, receive release notifications, ask questions, and get involved.

If this sounds interesting, and you would like to help us in creating the next generation of development tools, please reach out on our [website](${STORM_DEFAULT_CONTACT}) or join our [Slack](${STORM_DEFAULT_SOCIAL_SLACK}) channel!
`;

export const STORM_DEFAULT_ERROR_CODES_FILE = "tools/errors/codes.json";

export const STORM_DEFAULT_BANNER_ALT = "The workspace's banner image";
